module.exports = __webpack_public_path__ + "img/spanish.6141e2fc.png";